export default "./fonts/survio-2PVGv-font-Flaticon.woff";